import React, { FC } from 'react';

/**
 * Simple pill to display 'AI Beta' pill on promp modals.
 * @returns
 */
const AIBetaPill: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <div className="tw-mb-2 tw-h-[22px] tw-w-[59px] tw-rounded-rounded tw-border tw-border-solid tw-border-border-grey tw-px-[6px] tw-py-[3px]">
      <div className="tw-text-xs tw-font-normal tw-leading-none tw-text-primary-grey">AI beta</div>
    </div>
  );
};

export default AIBetaPill;
